/**
 * Visibility utilities for the navigation tree.
 *
 * @package @alchemiesolns/svg-interactive
 */

import type { MolecularWorkspace } from '@alchemiesolns/molecular-workspace';
import { VisibilityFlag } from '@alchemiesolns/visibility-config';

/**
 * Collect IDs of atoms marked as fully hidden (VisibilityFlag.Hidden).
 *
 * Used by HTMLStructureTree in navigation mode to omit non-visible atoms (and
 * any bonds touching them) from the screen-reader tree.
 */
export function collectHiddenAtomIds(workspace: MolecularWorkspace): Set<string> {
  const hidden = new Set<string>();
  for (const id of workspace.getAtomIds()) {
    if (workspace.getVisibility(id) === VisibilityFlag.Hidden) {
      hidden.add(id);
    }
  }
  return hidden;
}
